<template>
    <div>
         <p class="bigTitle"><span class="floor">*</span>商品管理>房价维护</p>
         <div class="body">
             <el-button type="primary" class="batchButtom">批量修改房价</el-button><br/>
             <div class="search">
                 <div class="block">
                        <span class="searchTime">起始时间:</span>
                        <el-date-picker
                            v-model="value2"
                            type="datetimerange"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="起始日期"
                            end-placeholder="结束日期"
                            align="right">
                        </el-date-picker>
                        <span class="searchName">商品名称:</span>
                        <el-input v-model="input" class="searchInput" placeholder="请输入商品名"></el-input>
                        <el-button type="primary" class="searchButtom">搜索</el-button>
                        <el-button type="primary" class="saveButtom">保存</el-button>
                </div>
             </div>
             <!-- 标题 -->
            <div class="excle">
                <div class="title">
                    <el-table
                        :data="tableData"
                        style="width: 98%;margin-bottom: 20px;background-color: #0F86DA" 
                        row-key="id"
                        border = false
                        :header-cell-style="tableHeaderColor"
                        :tree-props="{ hasChildren: 'hasChildren',children: 'children'}">
                        <el-table-column  prop="date"  label="商品名称" width="300" background-color="#0F86DA"> </el-table-column>
                        <el-table-column  prop="address" label="04/06  周一">
                        <el-input v-model="inputs" placeholder="请输入内容"></el-input>
                        </el-table-column>
                        <el-table-column  prop="address" label="04/07  周二">$266</el-table-column>
                        <el-table-column  prop="address" label="04/08  周三">$266 </el-table-column>
                        <el-table-column  prop="address" label="04/09  周四">$266 </el-table-column>
                        <el-table-column  prop="address" label="04/10  周五"> $266</el-table-column>
                        <el-table-column  prop="address" label="04/11  周六">$266 </el-table-column>
                        <el-table-column  prop="address" label="04/12  周日"> $266</el-table-column>
                     </el-table>
                </div>
            </div>

         </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7); 
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
        value2: '',
        inputs: 226,
        //表格
        tableData: [{
          id: 2,
          date: '高级双床房',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          id: 3,
          date: '豪华大床房',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          children: [{
              id: 31,
              date: '豪华大床房-2份早餐-免费取消',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
            }, {
              id: 32,
              date: '豪华大床房-入住日18:00前可免费取消',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
          }]
        }, {
          id: 4,
          date: '小单间',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }, {
          id: 5,
          date: '豪华大床房',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          children: [{
              id: 31,
              date: '豪华大床房-2份早餐-免费取消',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
            }, {
              id: 32,
              date: '豪华大床房-入住日18:00前可免费取消',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
          }]
        }],

      };
    },
    methods: {
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #409EFF;color: #fff'
      }
    }
  }
  };
</script>

<style scoped>

.bigTitle{
    text-align: left;
}

.floor{
    width: 15px;
    background-color: #0F86DA;
    color:#0F86DA;
    border-radius: 5px;
}

.body{
    background-color: #FFFFFF;
    border-radius: 10px;
}

.batchButtom{
    margin-top: 1%;
    margin-right: 90%;
    margin-bottom: 1%;
}

.searchName{
    margin-left: 2%;
}

.searchButtom{
   margin-right: 43%;
}

.searchInput{
    width: 10%;
}

.saveButtom{
    margin-bottom: 1%;
}

.table{
    margin-left: 1%;
}

.thead{
    width: 100%;
}

.thOne{
    width: 10%;
    background-color: #409EFF;
}
.thName{
    width: 20%;
    color: #FFFFFF;
    background-color: #409EFF;
     height:50px;
}

.thDay{
    width: 160px;
    color: #FFFFFF;
    background-color: #409EFF;
    text-align: center;
}

.trTime{
    width: 160px;
    text-align: center;
}
.trDay{
    text-align: center;
}

.title{
    margin-left: 1%;
}

.tableInput{
    height: 30px;
    border-radius: 5px;
}

</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/houseState/housePrice.vue